import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UniversitiesStore } from '../data-access/+state/universities.store';
import { HEADER_DATA } from '../static/universities.properties';
import { UniversitySearchScrollerService } from './university-search-scroller.service';
import { Product } from '@uc/web/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class UniversitiesService {
	readonly store = inject(UniversitiesStore);

	private _router = inject(Router);
	private _scrollSrv = inject(UniversitySearchScrollerService);

	headerData = signal({ ...HEADER_DATA });

	determineClearingRoute() {
		const isClearing = this._router.url.split('/').filter(Boolean)[1];
		return isClearing ? isClearing.startsWith('clearing') : false;
	}

	onStudyLevelSelect(product: Product) {
		this.store.updateProduct(product);
		this._navigate(product);
	}

	private async _navigate(studyLevel: Product) {
		const segments = ['/universities', studyLevel];

		const queryParams = this.store.queryParams();
		delete queryParams.page;

		await this._router.navigate(segments, { queryParams });

		this._scrollSrv.scroll();
	}
}
